export default {
  getCookie(cname) {
    const name = `${cname}=`
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i += 1) {
      const c = ca[i].trim()
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length)
    }
    return ''
  },
  setCookie(cname, cvalue, exdays) {
    const d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    const expires = `expires=${d.toGMTString()}`
    document.cookie = `${cname}=${cvalue}; ${expires}`
  },
  exportExcel(data, name) {
    const excelBlob = new Blob([data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
    // const excelBlob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })//导出xlsx格式：
    const oA = document.createElement('a')
    oA.href = window.URL.createObjectURL(excelBlob)
    oA.download = name
    oA.click()
  }

}

export const resMsg = (self, body) => {
  let title = '成功'
  let msg = body
  if (typeof body === 'object') {
    title = '失败'
    let arr = ''
    if (body.response) {
      arr = body.response.data.error.reason
    } else {
      arr = JSON.parse(body.message).error.reason
    }
    if (!Array.isArray(arr)) arr = arr.replace(/\[|\]/g, '').split(',')
    msg = `<p>${arr.join('</p><p>')}</p>`
  }
  self.$alert(msg, title, {
    dangerouslyUseHTMLString: true
  })
}

export const getTableData = (page = 1, pageSize = 10, totalData = []) => {
  const { length } = totalData
  const tableData = {
    data: [],
    total: length
  }
  if (pageSize >= length) { // pageSize大于等于总数据长度，说明只有1页数据或没有数据
    tableData.data = totalData
    tableData.page = 1// 直接取第一页
  } else { // pageSize小于总数据长度，数据多余1页
    const num = pageSize * (page - 1)// 计算当前页（不含）之前的所有数据总条数
    if (num < length) { // 如果当前页之前所有数据总条数小于（不能等于）总的数据集长度，则说明当前页码没有超出最大页码
      const startIndex = num// 当前页第一条数据在总数据集中的索引
      const endIndex = num + pageSize - 1// 当前页最后一条数据索引
      tableData.data = totalData.filter((_, index) => index >= startIndex && index <= endIndex)// 当前页数据条数小于每页最大条数时，也按最大条数范围筛取数据
    } else { // 当前页码超出最大页码，则计算实际最后一页的page，自动返回最后一页数据
      const size = parseInt(length / pageSize) // 取商
      const rest = length % pageSize // 取余数
      if (rest > 0) { // 余数大于0，说明实际最后一页数据不足pageSize，应该取size+1为最后一条的页码
        tableData.page = size + 1// 当前页码重置，取size+1
        tableData.data = totalData.filter((_, index) => index >= (pageSize * size) && index <= length)
      } else if (rest === 0) { // 余数等于0，最后一页数据条数正好是pageSize
        tableData.page = size// 当前页码重置，取size
        tableData.data = totalData.filter((_, index) => index >= (pageSize * (size - 1)) && index <= length)
      } // 注：余数不可能小于0
    }
  }
  return tableData
}

/**
 * 处理时间
 */
export const ExchangeDate = (val) => {
  const date = new Date(val)
  const fullYear = date.getFullYear()
  const month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
  const day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate()
  return fullYear + '-' + month + '-' + day
}

/**
 * 数组对象去重
 */
export const duplicate = (arr, type) => {
  if (arr.length === 0) {
    return arr
  } else {
    if (type) {
      var obj = {}
      var newArr = arr.reduce((cur, next) => {
        obj[next.name] ? '' : obj[next.name] = true && cur.push(next)
        return cur
      }, [])
      return newArr
    } else {
      return Array.from(new Set(arr))
    }
  }
}


export const debounce = (fn, delay) => {
  let delays = delay || 200
  let timer
  return function () {
    let th = this
    let args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      timer = null
      fn.apply(th, args)
    }, delays)
  }
}


export const formatTime = (date) => {
  let year = date.getFullYear()
  let _month = date.getMonth() + 1
  let day = date.getDate()

  let hour = date.getHours()
  let min = date.getMinutes()
  let sec = date.getSeconds()

  let month = _month > 10 ? _month : `0${_month}`
  let time = `${year}-${month}-${day} ${hour}:${min}:${sec}`
  return time
}
